module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('DeviceSetting')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), (_vm.showEasyPatch !== 'easysense') ? _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('MaxBasalRate')) + ": " + _vm._s(_vm.basal.max_rate) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Selected Basal Pattern')) + ": " + _vm._s(_vm.basal.basal_select))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('BasalPatterns')) + ": " + _vm._s(_vm.basal.basal_onoff))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_1"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph",
    attrs: {
      "id": "chart6_2",
      "element-loading-text": _vm.loadingText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_5"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreBasal),
      expression: "moreBasal"
    }]
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_8"
    }
  })]), _vm._v(" "), _vm._l((this.basalInfo), function(item) {
    return _c('div', [_c('div', {
      staticClass: "statics"
    }, [_c('p', {
      staticClass: "custom"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "margin-right": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t('24h Total')) + ": " + _vm._s(item.total) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg2show)),
        expression: "(item.bsg2show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg3show)),
        expression: "(item.bsg3show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg4show)),
        expression: "(item.bsg4show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch !== 'easysense') ? _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v("  " + _vm._s(_vm.$t('bolus')))])]), _vm._v(" "), (_vm.showEasyPatch === 'PDM') ? _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Maximum Bolus')) + ": " + _vm._s(_vm.bolus.max_bolus) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Increment')) + ": " + _vm._s(_vm.bolus.bolus_step) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Calculator')) + ": " + _vm._s(_vm.bolus.bolus_wizard))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Combo/Ext Bolus')) + ": " + _vm._s(_vm.bolus.extent_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG Reminder')) + ": " + _vm._s(_vm.bolus.bg_reminder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin Time')) + ": " + _vm._s(_vm.bolus.ins_active_time) + " ")])])])]) : _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Maximum Bolus')) + ": " + _vm._s(_vm.bolus.max_bolus) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Calculator')) + ": " + _vm._s(_vm.bolus.bolus_wizard))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin Time')) + ": " + _vm._s(_vm.bolus.ins_active_time) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('IC Ratios')) + "(g/" + _vm._s(_vm.$t('ins_unit2')) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Insulin Sensitivity')) + " " + _vm._s(_vm.unit))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('BG Target')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Range')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Reminder')) + " " + _vm._s(_vm.maxBolOption))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _vm._v(" "), (_vm.bolus_rem.length < 3) ? _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 2) ? _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 1) ? _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")]) : _vm._e()], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _vm._v(" "), (_vm.bolus_rem.length < 3) ? _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 2) ? _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 1) ? _c('td', [_vm._v("--")]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch === 'PDM') ? _c('div', [_c('div', {
    staticClass: "part part1"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('pdm')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ": " + _vm._s(_vm.userset.sensor_expire_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Confidence Reminder')) + ": " + _vm._s(_vm.userset.cmd_response))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ": " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Out_of_Range')) + ": " + _vm._s(_vm.userset.out_of_range_option) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Mode_Feature')) + ": " + _vm._s(_vm.userset.auto_basal.autobasalflag) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Time Format')) + ": " + _vm._s(_vm.userset.time_style))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Screen)')) + ": " + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Backlight)')) + ": " + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（CGM System)')) + ": " + _vm._s(_vm.userset.cgms_module_flag))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（Insulin Pump)')) + ": " + _vm._s(_vm.userset.pump_module_flag))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " : " + _vm._s(_vm.userset.clock_option))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Telephone')) + ": " + _vm._s(_vm.userset.telephone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " (" + _vm._s(_vm.userset.clock_option) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ":  " + _vm._s(_vm.cgm.sensor_alarm_option))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Alert Silence')) + ":  " + _vm._s(_vm.cgm.alarm_silent_option))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Snooze')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics middle-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Reminder')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Repeat')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_interval))]), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Graph Range')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.trend_time_scope) + "H")]), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight === 0 ? '--' : _vm.userset.auto_basal.AutoBasalWeight + 'kg') + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD === 0 ? '--' : _vm.userset.auto_basal.AutoBasalTDD + 'U') + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch === 'easypatch') ? _c('div', [_c('div', {
    staticClass: "part part1"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Pump')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Pump_Bash_SN')) + ": " + _vm._s(_vm.pumpSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Out_of_Range')) + ": " + _vm._s(_vm.userset.out_of_range_option))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Command_Reminder')) + ": " + _vm._s(_vm.userset.cmd_response))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {})])])]), _vm._v(" "), _c('div', {
    staticClass: "small-table-wrap"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_Alerts_on_APP')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Audio')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t(_vm.userset.pump_alarm_audio_option)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Vibrate')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t(_vm.userset.pump_alarm_vibrate_option)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Pump_Light')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.$t(_vm.userset.easypatch_pump_light)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_tone.split('.')[0]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_tone.split('.')[0]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Transmitter_SN')) + ": " + _vm._s(_vm.tranSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ":" + _vm._s(_vm.userset.sensor_expire_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ": " + _vm._s(_vm.cgm.sensor_alarm_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Factory_Calibration')) + ": " + _vm._s(_vm.$t(_vm.userset.factory_calibration_option)))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Low')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_High')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Others')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1029_Alerts_for_Hypo')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_hypo_tone))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('APP')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Weight_Unit')) + ": " + _vm._s(_vm.userset.easypatch_weight_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Height_Unit')) + ": " + _vm._s(_vm.userset.easypatch_height_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('EasyLoop')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ":  " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight) + " kg ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD) + " U")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch === 'easysense') ? _c('div', [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Transmitter_SN')) + ": " + _vm._s(_vm.tranSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ":" + _vm._s(_vm.userset.sensor_expire_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ": " + _vm._s(_vm.cgm.sensor_alarm_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Factory_Calibration')) + ": " + _vm._s(_vm.$t(_vm.userset.factory_calibration_option)))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Low')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_High')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Others')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1029_Alerts_for_Hypo')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_hypo_tone))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('APP')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Weight_Unit')) + ": " + _vm._s(_vm.userset.easypatch_weight_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Height_Unit')) + ": " + _vm._s(_vm.userset.easypatch_height_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('DeviceSetting')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "time-range"
  }, [_c('p', {
    staticStyle: {
      "margin-right": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Source')))])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('table', {
    staticClass: "pdm",
    attrs: {
      "id": "pdm"
    }
  }, _vm._l((_vm.PDM), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "select"
    }, [_c('label', {
      class: {
        'no': item[0] == _vm.tempSelectId
      },
      attrs: {
        "id": item[0]
      },
      on: {
        "click": _vm.choose
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[2]))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': !_vm.has_prev
    },
    attrs: {
      "src": require("../../assets/chart6-icon/arrow_right_m.png")
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.pages))]), _vm._v(" "), _c('img', {
    class: {
      'click1': !_vm.has_next
    },
    attrs: {
      "src": require("../../assets/chart6-icon/arrow_left_m.png")
    },
    on: {
      "click": _vm.nextPage
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.$t('Apply')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ba5fbaf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-template/chart6.vue
// module id = 1424
// module chunks = 7